// src/pages/Operator/ParcelList.jsx
import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Badge, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const ParcelList = () => {
    const [parcels, setParcels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('');

    useEffect(() => {
        // Simulation chargement
        setTimeout(() => {
            setParcels([
                { id: 1, tracking_number: 'CAC12345678', recipient_name: 'Mamadou Fofana', current_status: 'registered', created_at: new Date() },
                { id: 2, tracking_number: 'CAC87654321', recipient_name: 'Aminata Diallo', current_status: 'transit_air', created_at: new Date() },
                { id: 3, tracking_number: 'CAC11223344', recipient_name: 'Ousmane Traore', current_status: 'delivered', created_at: new Date() }
            ]);
            setLoading(false);
        }, 1000);
    }, []);

    const getStatusBadge = (status) => {
        const config = {
            registered: { text: '📝 Enregistré', variant: 'secondary' },
            transit_air: { text: '✈️ En transit (aérien)', variant: 'primary' },
            transit_sea: { text: '🚢 En transit (maritime)', variant: 'primary' },
            arrived: { text: '📦 Arrivé', variant: 'warning' },
            delivering: { text: '🚚 En livraison', variant: 'info' },
            delivered: { text: '✅ Livré', variant: 'success' },
            incident: { text: '⚠️ Incident', variant: 'danger' }
        };
        return config[status] || { text: status, variant: 'secondary' };
    };

    const filteredParcels = parcels.filter(parcel => {
        const matchSearch = parcel.tracking_number.toLowerCase().includes(searchTerm.toLowerCase()) ||
            parcel.recipient_name.toLowerCase().includes(searchTerm.toLowerCase());
        const matchStatus = !statusFilter || parcel.current_status === statusFilter;
        return matchSearch && matchStatus;
    });

    if (loading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                <Spinner animation="border" style={{ color: '#C62828' }} />
            </Container>
        );
    }

    return (
        <Container className="py-4">
            <Card className="border-0 shadow-lg rounded-4">
                <Card.Header className="bg-white border-0 pt-4">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div>
                            <h2 className="fw-bold mb-0" style={{ color: '#C62828' }}>
                                📦 Liste des colis
                            </h2>
                            <p className="text-muted mt-1">Gérez tous vos shipments</p>
                        </div>
                        <Button as={Link} to="/operator/parcels/create" style={{ backgroundColor: '#C62828', borderColor: '#C62828' }}>
                            + Nouveau colis
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body className="p-4">
                    {/* Filtres */}
                    <Row className="mb-4">
                        <Col md={6} className="mb-3 mb-md-0">
                            <Form.Control
                                type="text"
                                placeholder="Rechercher par numéro ou destinataire..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Select
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                            >
                                <option value="">Tous les statuts</option>
                                <option value="registered">Enregistré</option>
                                <option value="transit_air">En transit (aérien)</option>
                                <option value="transit_sea">En transit (maritime)</option>
                                <option value="arrived">Arrivé</option>
                                <option value="delivering">En livraison</option>
                                <option value="delivered">Livré</option>
                                <option value="incident">Incident</option>
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Button variant="outline-secondary" onClick={() => { setSearchTerm(''); setStatusFilter(''); }} className="w-100">
                                Réinitialiser
                            </Button>
                        </Col>
                    </Row>

                    {/* Tableau */}
                    <Table responsive hover>
                        <thead className="bg-light">
                            <tr>
                                <th className="p-3">N° Suivi</th>
                                <th className="p-3">Destinataire</th>
                                <th className="p-3">Statut</th>
                                <th className="p-3">Date</th>
                                <th className="p-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredParcels.map((parcel) => {
                                const status = getStatusBadge(parcel.current_status);
                                return (
                                    <tr key={parcel.id}>
                                        <td className="p-3 font-monospace fw-bold">{parcel.tracking_number}</td>
                                        <td className="p-3">{parcel.recipient_name}</td>
                                        <td className="p-3">
                                            <Badge bg={status.variant} className="px-3 py-2">
                                                {status.text}
                                            </Badge>
                                        </td>
                                        <td className="p-3">{new Date(parcel.created_at).toLocaleDateString('fr-FR')}</td>
                                        <td className="p-3">
                                            <Button variant="outline-primary" size="sm">
                                                Voir détails
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>

                    {filteredParcels.length === 0 && (
                        <div className="text-center py-5">
                            <p className="text-muted">Aucun colis trouvé</p>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default ParcelList;